import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const PRO_FEATURES = [
  'Unlimited Cosmic Learning AI tutor chat',
  'Full access to all practice exercises',
  'Detailed AI feedback on writing & speaking',
  'Priority access to new features',
];

export default function Pricing() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [working, setWorking] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    api
      .billingStatus()
      .then((data) => active && setStatus(data))
      .catch(() => active && setStatus(null))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  const handleSubscribe = async () => {
    setError('');
    setWorking(true);
    try {
      const res = await api.createCheckout();
      window.location.href = res.url;
    } catch (err) {
      setError(err.message || 'Could not start checkout. Please try again.');
      setWorking(false);
    }
  };

  const handleManage = async () => {
    setError('');
    setWorking(true);
    try {
      const res = await api.billingPortal();
      window.location.href = res.url;
    } catch (err) {
      setError(err.message || 'Could not open the billing portal. Please try again.');
      setWorking(false);
    }
  };

  const isActive = status?.active;

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-14">
      <h1 className="bg-gradient-to-r from-primary to-accent bg-clip-text text-3xl font-bold tracking-tight text-transparent">
        Cosmic Learning Pro
      </h1>
      <p className="mt-2 text-center text-sm text-muted-foreground">
        Unlock the full learning experience.
      </p>

      <div className="mt-8 w-full rounded-2xl border border-border/60 bg-card/80 p-6 shadow-xl shadow-primary/10 backdrop-blur-xl">
        <div className="flex items-baseline gap-1">
          <span className="text-4xl font-bold text-foreground">$9</span>
          <span className="text-sm text-muted-foreground">/ month</span>
        </div>

        <ul className="mt-6 space-y-3">
          {PRO_FEATURES.map((feature) => (
            <li key={feature} className="flex items-start gap-2.5 text-sm text-foreground">
              <svg className="mt-0.5 shrink-0 text-primary" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {feature}
            </li>
          ))}
        </ul>

        {error && (
          <div className="mt-5 rounded-lg border border-destructive/30 bg-destructive/10 px-3 py-2 text-xs text-destructive">
            {error}
          </div>
        )}

        <div className="mt-6">
          {loading ? (
            <div className="h-12 w-full animate-pulse rounded-xl bg-muted" />
          ) : isActive ? (
            <div className="space-y-3">
              <div className="rounded-lg border border-primary/30 bg-primary/10 px-3 py-2 text-center text-sm font-medium text-primary">
                You’re subscribed to Pro
              </div>
              <button
                type="button"
                onClick={handleManage}
                disabled={working}
                className="min-h-[3rem] w-full rounded-xl border border-border bg-card text-sm font-semibold text-foreground transition-colors hover:bg-muted disabled:opacity-50"
              >
                {working ? 'Opening…' : 'Manage subscription'}
              </button>
            </div>
          ) : (
            <button
              type="button"
              onClick={handleSubscribe}
              disabled={working}
              className="min-h-[3rem] w-full rounded-xl bg-gradient-to-r from-primary to-accent text-sm font-semibold text-primary-foreground shadow-lg shadow-primary/25 transition-opacity hover:opacity-95 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {working ? 'Redirecting…' : 'Subscribe to Pro'}
            </button>
          )}
        </div>

        <p className="mt-4 text-center text-[11px] text-muted-foreground">
          Secure payment by Stripe. Cancel anytime.
        </p>
      </div>
    </div>
  );
}
